<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<app-customer-form (apiKey)="setApiKey($event)" [customerId]="id"></app-customer-form>

<div class="mt-5" *ngIf="apiKey">
  <app-contract-users-table [apiKey]="apiKey"></app-contract-users-table>
</div>
